<template>
  <div>
    <h1 class="text-3xl font-bold mb-6 text-center text-gray-800">2. Provide Answer Key (Optional)</h1>
    <p class="text-center text-gray-600 mb-4">Copy and paste the answer key or rubric into the textbox below.</p>
    <div class="flex justify-center space-x-4 mb-6">
      <button @click="goToUpload" class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition">Upload as File</button>
      <button @click="goToQR" class="bg-indigo-500 text-white px-4 py-2 rounded hover:bg-indigo-600 transition">Scan with Phone</button>
    </div>
    <textarea
        v-model="answersContent"
        class="w-full border border-gray-300 bg-white rounded-lg p-4 resize-y"
        rows="15"
        placeholder="(Optional) Enter all evaluation material here. If left blank, we will try to auto-generate it."
        ref="textarea"
    ></textarea>

    <!-- Navigation Buttons -->
    <div class="flex justify-between mt-8">
      <button
          @click="goBack"
          class="bg-gray-500 text-white px-4 py-2 rounded transition hover:bg-gray-600 flex items-center min-w-[120px] justify-center"
          :disabled="loading"
      >
        Back
      </button>

      <button
          @click="triggerNext"
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition flex items-center min-w-[120px] justify-center"
          :disabled="loading">
        <svg v-if="loading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V4a10 10 0 00-10 10h2zm0 0a8 8 0 018 8v-2a6 6 0 00-6-6H4z"></path>
        </svg>
        <span v-if="loading">Processing...</span>
        <span v-else>{{ buttonText }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from '../services/axiosInstance'
import { useModalStore } from '@/stores/modal'

const answersContent = ref('')
const router = useRouter()
const route = useRoute()
const loading = ref(false)
const modal = useModalStore()

const buttonText = computed(() => 'Generate Instructions')

onMounted(async () => {
  const testId = route.params.testId
  if (!testId) return
  try {
    const response = await axios.get(`/tests/${testId}/answers`)
    answersContent.value = response.data.content ?? ''
  } catch (error) {
    console.error('Error fetching answers content:', error)
  }
})

const goToUpload = () => router.push({ name: 'AnswersUpload', params: { testId: route.params.testId }, query: route.query })
const goToQR = () => router.push({ name: 'AnswersQR', params: { testId: route.params.testId }, query: route.query })

const goBack = () => {
  router.go(-1)
}

const triggerNext = async () => {
  loading.value = true
  const testId = route.params.testId
  try {
    await axios.put(`/tests/${testId}/answers`, { content: answersContent.value })
    await axios.post(`/tests/${testId}/instruction/generate`, {}, { timeout: 180000 })
    router.push({ name: 'InstructionsEditor', params: { testId } })
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      modal.error('Instruction generation timed out.')
    } else {
      modal.error('An error occurred while generating instructions.')
    }
  } finally {
    loading.value = false
  }
}
</script>
